import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { DashboardData } from '../../types'
import { statsApi } from '../api/statsApi'

const defaultStatsData: DashboardData = {
  grantsTotal: 0,
  grantsAwarded: 0,
  worksAwarded: 0,
  worksNotAwarded: 0,
  grantees: 0,
  grantMoneyAwarded: 0,
  topGrantees: [],
  grantByAreaStats: [],
  grantByYearStats: [],
  grantByStatusStats: [],
}

export interface StatsState {
  stats: DashboardData
}

const initialState: StatsState = {
  stats: defaultStatsData,
}

export const statsSlice = createSlice({
  name: 'stats',
  initialState,
  reducers: {
    setStats: (state, action: PayloadAction<DashboardData>) => {
      state.stats = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(statsApi.endpoints.getStats.matchFulfilled, (state, { payload }) => {
      state.stats = payload
    })
  },
})

// Action creators are generated for each case reducer function
export const { setStats } = statsSlice.actions

export default statsSlice.reducer
